import React, {Component} from "react";

import styles from "./User.module.scss";

class User extends React.Component {

    render() {
        const { name, position, description, picture, alt, twitter } = this.props;
        return (
            <div className={styles.fh5coperson}>	
                <figure className="animate-box">
                    <img src={picture} alt={alt} className="img-fluid" />
                </figure>
                <h3 className={` ${styles.fh5coname} animate-box`}>{name}</h3>
                <h4 className={` ${styles.fh5codesignation} animate-box`}>{position}</h4>
                <p className={` ${styles.fh5cobio} animate-box`}>{description}</p>
                <ul className={styles.fh5cosocial}>
                    <li className="animate-box"><a href={twitter} target="_blank" rel="nofollow" title={"Twitter de "+name}><i className="icon-twitter"></i></a></li>
                </ul>
            </div>
        );
    }
}

export default User;



// WEBPACK FOOTER //
// ./src/components/Section/User.jsx